import { combineReducers } from "redux";
import SignUpReducer from "./auth/signUpReducer";
import SignInReducer from "./auth/signInReducer";
import ForgotPasswordReducer from "./auth/forgotPasswordReducer";
import { resetPasswordReducer } from "./auth/resetPasswordReducer";
import sendOtpReducer from "./auth/sendOtpReducer";
import otpVerificationReducer from "./auth/otpVerificationReducer";

import stepOneReducer from "./onBoarding/stepOneReducer";
import stepTwoReducer from "./onBoarding/stepTwoReducer";
import stepThreeReducer from "./onBoarding/stepThreeReducer";
import stepFourReducer from "./onBoarding/stepFourReducer";
import stepFiveReducer from "./onBoarding/stepFiveReducer";
import stepSixReducer from "./onBoarding/stepSixReducer";

import getStepOneReducer from "./onBoarding/getStepOneReducer";
import getStepTwoReducer from "./onBoarding/getStepTwoReducer";
import getStepThreeReducer from "./onBoarding/getStepThreeReducer";
import getStepFourReducer from "./onBoarding/getStepFourReducer";
import getStepFiveReducer from "./onBoarding/getStepFiveReducer";
import getStepSixReducer from "./onBoarding/getStepSixReducer";
import globalFeedCreationReducer from "./globalFeeds/globalFeedCreationReducer";
import fetchMyGlobalFeedsReducer from "./globalFeeds/fetchMyGlobalFeedsReducer";
import logoutReducer from "./auth/logoutReducer";
import getCurrentUserDetailsReducer from "./profile/getCurrentUserDetailsReducer";
import localFeedCreationReducer from "./localFeeds/localFeedCreationReducer";
import fetchMyLocalFeedsReducer from "./localFeeds/fetchMyLocalfeedsReducer";
import locationReducer from "./location/locationReducer";
import getReachDistanceDataReducer from "./common/getReachDistanceDataReducer";
import getPostCommentsReducer from "./reactions/getPostCommentsReducer";

import getAllRadiusReducer from "./radius/getAllRediusReducer";
import getRadiusDetailsReducer from "./radius/getRadiusDetailsReducer";
import getRelatedBusinessesReducer from "./radius/getRelatedBusinessesReducer";

import addPostViewReducer from "./reactions/addPostViewReducer";
import { changePasswordReducer } from "./profile/changePasswordReducer";
import getBusinessReducer from "./radius/getBusinessReducer";
import getOffersReducer from "./offers/getOffersReducer";
import postOfferReducer from "./offers/postOfferReducer";
import deleteOfferReducer from "./offers/deleteOfferReducer";
import updateOfferReducer from "./offers/updateOfferReducer";
import getReviewsReducer from "./radius/getReviewReducer";
import getFavoritesReducer from "./radius/getFavoritesReducer";
import getFollowedBusinessesReducer from "./profile/getFollowedBusinessesReducer";
import followBusinessReducer from "./profile/followBusinessReducer";
import getJobsReducer from "./jobs/getJobsReducer";
import postJobReducer from "./jobs/postJobReducer";
import updateJobReducer from "./jobs/updateJobReducer";
import deleteJobReducer from "./jobs/deleteJobReducer";
import postReviewReducer from "./radius/postReviewReducer";
import initiatePaymentReducer from "./payments/initiatePaymentReducer";
import checkPaymentStatusReducer from "./payments/checkPaymentStatusReducer";
import getPaymentHistoryReducer from "./payments/getPaymentHistoryReducer";
import getSubscriptionPlansReducer from "./subscription/getSubscriptionPlansReducer";
import subscribePlanReducer from "./subscription/subscribePlanReducer";
import cancelSubscriptionReducer from "./subscription/cancelSubscriptionReducer";
import selectedPlanReducer from "./subscription/selectedPlanReducer";
import { getTermsAndConditionsReducer, getPrivacyPolicyReducer, getCancellationRefundPolicyReducer } from "./common/getLegalContentReducer";
import businessUpgradeRequestReducer from "./businessUpgrade/businessUpgradeRequestReducer";

import * as types from "../actions/ActionTypes";

const appReducer = combineReducers({
  signUp: SignUpReducer,
  signIn: SignInReducer,
  forgotPassword: ForgotPasswordReducer,
  resetPassword: resetPasswordReducer,
  sendOtp: sendOtpReducer,
  otpVerification: otpVerificationReducer,
  stepOne: stepOneReducer,
  stepTwo: stepTwoReducer,
  stepThree: stepThreeReducer,
  stepFour: stepFourReducer,
  stepFive: stepFiveReducer,
  stepSix: stepSixReducer,

  getStepOne: getStepOneReducer,
  getStepTwo: getStepTwoReducer,
  getStepThree: getStepThreeReducer,
  getStepFour: getStepFourReducer,
  getStepFive: getStepFiveReducer,
  getStepSix: getStepSixReducer,

  globalFeedCreation: globalFeedCreationReducer,
  localFeedCreation: localFeedCreationReducer,
  fetchMyGlobalFeeds: fetchMyGlobalFeedsReducer,
  fetchMyLocalFeeds: fetchMyLocalFeedsReducer,
  getCurrentUserDetails: getCurrentUserDetailsReducer,
  logout: logoutReducer,
  location: locationReducer,
  getReachDistanceData: getReachDistanceDataReducer,
  getPostComments: getPostCommentsReducer,
  fetchAllRadiusData: getAllRadiusReducer,
  fetchRadiusDetailsData: getRadiusDetailsReducer,
  relatedBusinesses: getRelatedBusinessesReducer,
  addPostView: addPostViewReducer,
  changePassword: changePasswordReducer,
  getBusiness: getBusinessReducer,
  getOffers: getOffersReducer,
  postOffer: postOfferReducer,
  deleteOffer: deleteOfferReducer,
  updateOffer: updateOfferReducer,
  getReviews: getReviewsReducer,

  getFavorites: getFavoritesReducer,
  getFollowedBusinesses: getFollowedBusinessesReducer,
  followBusiness: followBusinessReducer,
  getJobs: getJobsReducer,
  postJob: postJobReducer,
  updateJob: updateJobReducer,
  deleteJob: deleteJobReducer,
  postReview: postReviewReducer,
  initiatePayment: initiatePaymentReducer,
  checkPaymentStatus: checkPaymentStatusReducer,
  getPaymentHistory: getPaymentHistoryReducer,
  getSubscriptionPlans: getSubscriptionPlansReducer,
  subscribePlan: subscribePlanReducer,
  cancelSubscription: cancelSubscriptionReducer,
  selectedPlan: selectedPlanReducer,
  getTermsAndConditions: getTermsAndConditionsReducer,
  getPrivacyPolicy: getPrivacyPolicyReducer,
  getCancellationRefundPolicy: getCancellationRefundPolicyReducer,
  businessUpgradeRequest: businessUpgradeRequestReducer,
});

const rootReducer = (state, action) => {
  if (action.type === types.LOGOUT_SUCCESS || action.type === types.RESET_APP_STATE) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;

